import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface ContactInfoProps {
  contactPhoneNumber: string;
}

export function ContactInfo({ contactPhoneNumber }: ContactInfoProps) {
  return (
    <Box display="flex" flexDirection="row" mb={3}>
      <IconButton
        sx={(theme) => ({ marginRight: theme.spacing(2) })}
        data-testid="question-icon"
        size="large">
        <HelpOutlineIcon />
      </IconButton>
      <Box display="flex" flexDirection="column">
        <Typography
          variant="subtitle1"
          lineHeight={1}
          data-testid="any-questions">
          Any questions?
        </Typography>
        <Typography
          variant="body2"
          lineHeight={10 / 9}
          mt={0.5}
          data-testid="phone-number">
          {contactPhoneNumber}
        </Typography>
      </Box>
    </Box>
  );
}
